const ACTION_TEXTS = {
  message: 'Message',
  activate: 'Activate',
};
export default ACTION_TEXTS;
